import styled from 'styled-components';
import { motion } from 'motion/react';
import { BodyLgReg, BodySmReg, FrostedGlassLight } from '@seed-health/tokens';
import Link from 'next/link';
import { mqSmallMax } from 'styled/tools/media-queries';

export const Wrapper = styled.div`
  position: fixed;
  z-index: 13;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 480px;
  height: 64px;
  margin: var(--spacing-16);
  overflow: clip;
  border-radius: var(--radius-full);

  @media ${mqSmallMax} {
    left: 0;
    max-width: unset;
    width: auto;
    height: 52px;
  }
`;

export const MotionPillBackground = styled(motion.div)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  border-radius: var(--radius-full);
  background: var(--scrim-glass-dark-35);
  backdrop-filter: ${FrostedGlassLight};
  -webkit-backdrop-filter: ${FrostedGlassLight};
  pointer-events: none;
`;

export const DynamicElementsRow = styled.div`
  position: absolute;
  left: var(--spacing-8);
  right: var(--spacing-8);
  top: var(--spacing-16);
  bottom: var(--spacing-16);
  display: flex;
  align-items: center;
  gap: var(--spacing-8);
`;

export const ProductImage = styled(motion.img)`
  width: 48px;
  height: 48px;
  border-radius: var(--radius-full);
  background: var(--scrim-glass-light-20);
  object-fit: cover;
  flex-shrink: 0;

  @media ${mqSmallMax} {
    width: 36px;
    height: 36px;
  }
`;

export const TitleMask = styled.span`
  display: flex;
  flex: 1;
  min-width: 0;
`;

export const TextContainer = styled(motion.span)`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0 0.25em;
`;

export const WordMask = styled.span`
  display: inline-block;
  overflow: hidden;
  ${BodyLgReg}

  @media ${mqSmallMax} {
    ${BodySmReg}
  }
`;

export const Word = styled(motion.span)`
  display: inline-block;
  color: var(--text-inverse-primary);
`;

export const CTAWrapper = styled(motion.div)`
  margin-left: auto;
  flex-shrink: 0;
`;

export const InlineLinkStyled = styled(Link)`
  display: flex;
  text-decoration: none;
`;
